import activeCountries from "../../activeCountries";
import React, {useContext, useState} from "react";
import Select from "@ui-components/Select";
import CountryContext from "../../CountryContext";
import {useLocation} from "react-router-dom";
import Spinner from "@ui-components/Spinner";

export const PublicHeader = ({ showCountrySelector = true }) => {

  // context
  const { country } = useContext(CountryContext);

  // hooks
  const { pathname } = useLocation();

  // state
  const [selectedCountryCode, setSelectedCountryCode] = useState(country.code);

  // utilities
  const countryOptions = activeCountries
    .map(({code, name}) => ({value: code, name}));
  const onCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    const selected = activeCountries
      .find(({code}) => code === e.target.value);
    if (!selected) return;

    // change selector state
    setSelectedCountryCode(selected.code);

    // redirect to country page
    window.location.href = pathname.replace(
      `/${country.code}/`,
      `/${selected.code}/`
    )
  }
  const countryChanged = selectedCountryCode !== country.code;

  return (
    <div className="w-full flex items-center justify-between bg-white px-4 sm:px-8 py-3 shadow-lg z-10">
      <img
        className="hidden sm:block w-72"
        src={process.env.PUBLIC_URL + "/logo-kerakoll.svg"}
        alt="logo"
      />
      <img
        className="sm:hidden w-36"
        src={process.env.PUBLIC_URL + "/logo-kerakoll-tight.svg"}
        alt="logo"
      />
      <div className={`flex flex-row gap-2 items-center ${showCountrySelector ? "visible" : "invisible"}`}>
        <Select
          label={undefined}
          options={countryOptions}
          value={selectedCountryCode}
          onChange={onCountryChange}
          className="mt-2"
          disabled={countryChanged}
        />
        {countryChanged && (
          <div className="relative w-8" style={{aspectRatio: "1"}}>
            <Spinner
              classes={undefined}
              styleType="white"
            />
          </div>
        )}
      </div>
    </div>
  )
}